import { IProduct, IVoicePackage } from "../../fetchOrderProducts";

export function isVoicePackage(product: IProduct): product is IVoicePackage {
  return (
    "specificationId" in product && product.specificationId === "VOICE_PACKAGE"
  );
}
